/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CheckoutBoxHeader from "../../CheckoutBoxHeader";
import UserCheckoutAddresses from "../../../user-checkout-helpers/user-receiving-methods/UserCheckoutAddresses";
import ReceivingTime from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/receiving-time/ReceivingTime";
import DisabledMethodMSg from "../../checkout-error-messages/DisabledMethodMSg";
import { CheckoutIcons } from "../../../checkout-icons/GetCheckoutSvg";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import ReceivingAccordion from "./ReceivingAccordion";
import DeliveryBranches from "./DeliveryBranches";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { RecievingFields } from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/helpers";
import { useAtom } from "jotai";
import { isSignedInAtom } from "@/hooks/authAtoms";
import GuestAddressSection from "./GuestAddressSection";
import CheckoutErrMsg from "../../checkout-error-messages/CheckoutErrMsg";
import { useGetDeliveryBranches } from "@/api/AppApi/services/cart";
import { disableSubmitBtnAtom } from "@/hooks/receivingHeaderAtom";

interface props {
  enabled: boolean;
  isMobile: boolean;
  addressIdFieldName: string;
  timeField: IField;
  form: UseFormReturn<FieldValues, any>;
  shipping_not_available_message: string;
}
const DeliverySection: React.FC<props> = ({
  enabled,
  isMobile,
  addressIdFieldName,
  form,
  timeField,
  shipping_not_available_message,
}) => {
  const branchFieldName = RecievingFields.preferredBranchFieldName;
  const t = useTranslation();
  const [isSignin] = useAtom(isSignedInAtom);
  const [addressId, setAddressId] = useState<number>();
  const [areaId, setAreaId] = useState<number>();
  const [, setDisableSubmitBtn] = useAtom(disableSubmitBtnAtom);
  const getDeliveryBranches = useGetDeliveryBranches({
    enabled: !!addressId || !!areaId,
    address_id: addressId!,
    area_id: areaId!,
  });
  const branches = getDeliveryBranches?.data?.result ?? [];
  const disableSelectBranch = !branches.length;
  const [disableSelectTime, setDisableSelectTime] = useState(
    !form.watch(RecievingFields.preferredBranchFieldName),
  );
  useEffect(() => {
    setAddressId(form.getValues(RecievingFields.addressIdFieldName));
    setAreaId(form.getValues(RecievingFields.areaField)?.key);
    setDisableSubmitBtn(disableSelectBranch);
  }, [
    form.watch(RecievingFields.addressIdFieldName),
    form.watch(RecievingFields.areaField),
    disableSelectBranch,
  ]);
  useEffect(() => {
    setDisableSelectTime(!form.watch(RecievingFields.preferredBranchFieldName));
  }, [form.watch(RecievingFields.preferredBranchFieldName)]);
  return enabled ? (
    <ReceivingAccordion
      accordionItems={[
        {
          accordionHeader: (
            <CheckoutBoxHeader
              svg={CheckoutIcons.popUpDelivery}
              title={t.delivery_address}
              mobile={isMobile}
              withoutBorder
            />
          ),
          accordionBody: isSignin ? (
            <UserCheckoutAddresses
              form={form}
              fieldName={addressIdFieldName}
              mobile={isMobile}
            />
          ) : (
            <GuestAddressSection form={form} />
          ),
          disabled: false,
          others: disableSelectBranch && (
            <CheckoutErrMsg
              message={
                t.sorry_there_is_no_branch_serving_the_area_you_selected_Please_choose_another_area
              }
            />
          ),
        },
        {
          accordionHeader: (
            <CheckoutBoxHeader
              svg={CheckoutIcons.pickup}
              title={t.preferred_branch}
              mobile={isMobile}
              withoutBorder
            />
          ),
          accordionBody: (
            <DeliveryBranches
              form={form}
              fieldName={branchFieldName}
              mobile={isMobile}
              branches={branches!}
            />
          ),
          disabled: disableSelectBranch,
          others: form.formState.errors[
            RecievingFields.preferredBranchFieldName
          ]?.message && (
            <CheckoutErrMsg
              message={
                form.formState.errors[RecievingFields.preferredBranchFieldName]
                  ?.message as string
              }
            />
          ),
        },
        {
          accordionHeader: (
            <CheckoutBoxHeader
              svg={CheckoutIcons.popUpDeliveryTime}
              title={t.delivery_time}
              mobile={isMobile}
              withoutBorder
            />
          ),
          accordionBody: (
            <ReceivingTime
              form={form}
              timeField={timeField}
              timeTypeFieldName={RecievingFields.deliveryTimeTypeFieldName}
            />
          ),
          disabled: disableSelectTime,
        },
      ]}
    />
  ) : (
    <DisabledMethodMSg message={shipping_not_available_message} />
  );
};

export default DeliverySection;
